<template>
    <div id="studentinfo">
        <!-- {{PlugJson}} -->
    </div>
</template>

<script>
export default {
    name:'studentinfo'
}
</script>

<style scoped>

</style>